import { Box, TableCell } from "@mui/material";
import SalesPermissionStatusIndicator from "../common/SalesPermissionStatusIndicator";
import SalesPermissionText from "../common/SalesPermissionText";
import { SalesPermission } from "../types/queries";

type Props = {
  salesPermission: SalesPermission;
};

const SalesPermissionCell = ({ salesPermission }: Props) => {
  const { verificationDate, riskLevel } = salesPermission;

  return (
    <TableCell>
      <Box display="flex" alignItems="center" gap="10px">
        <SalesPermissionStatusIndicator riskLevel={riskLevel} />
        <SalesPermissionText verificationDate={verificationDate} />
      </Box>
    </TableCell>
  );
};

export default SalesPermissionCell;
